import { 
  Box, Tabs, Tab, Typography 
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { EnvironmentApis } from "./EnvironmentApis";
import { EnvironmentMonitor } from "./EnvironmentMonitor";
import { ObservabilityView } from "./ObservabilityView";
import React from "react";
import ChatInterface from "../ai/chat/ChatInterface";

export const Developer = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function CustomTabPanel(props: { children?: React.ReactNode, index: number, value: number }) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="APIs" {...a11yProps(0)} />
          <Tab label="Monitor" {...a11yProps(1)} />
          <Tab label="Observability" {...a11yProps(2)} />
          <Tab label="Documentation" {...a11yProps(3)} />
          <Tab label="Environment Agent" {...a11yProps(4)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <EnvironmentApis />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <EnvironmentMonitor />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <ObservabilityView />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>
        Documentation
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <ChatInterface isDrawer={false} />
      </CustomTabPanel>

    </Box>
  );
};

export default Developer;

/*import {
  Box,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation, To, Routes, Route } from "react-router-dom";

import { CommerceServicesApis } from "./CommerceServices";
import { ConciergeApis } from "./Concierge";
import React from "react";
import { EnvironmentEdit, EnvironmentList } from "./Environment";
import { LogShow } from "./logs/Logs";
import LogListWithProvider from "./logs/LogsListWithProvider";

export const Developer = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname;

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleTabChange = (event: any, newValue: To) => {
    navigate(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Commerce Services" {...a11yProps(0)} />
          <Tab label="Logs" {...a11yProps(1)} />
          <Tab label="Environments" {...a11yProps(2)} />
          <Tab label="Documentation" {...a11yProps(3)} />
        </Tabs>
      </Box>
      
      <CustomTabPanel value={value} index={0}>
        <CommerceServicesApis />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Routes>
          <Route path="/" element={<LogListWithProvider />} />
          <Route path="/log/:id" element={<LogShow />} />
        </Routes>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Routes>
          <Route path="/" element={<EnvironmentList />} />
          <Route path="/environment/:id" element={<EnvironmentEdit />} />
        </Routes>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        Documentation
      </CustomTabPanel>
    </Box>
  );
};

export default Developer;
*/
